/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ username: NonNullable<unknown> }} Onboarding_V1_Interests_HeadingInputs */

const en_onboarding_v1_interests_heading = /** @type {(inputs: Onboarding_V1_Interests_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`What do you want to invest in, ${i?.username}?`)
};

const de_onboarding_v1_interests_heading = /** @type {(inputs: Onboarding_V1_Interests_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`In was möchten Sie investieren, ${i?.username}?`)
};

const pt_br2_onboarding_v1_interests_heading = /** @type {(inputs: Onboarding_V1_Interests_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Em que você quer investir, ${i?.username}?`)
};

const tr_onboarding_v1_interests_heading = /** @type {(inputs: Onboarding_V1_Interests_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nelere yatırım yapmak istiyorsunuz, ${i?.username}?`)
};

const zh_cn2_onboarding_v1_interests_heading = /** @type {(inputs: Onboarding_V1_Interests_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.username}，您想投资什么？`)
};

const zh_hk2_onboarding_v1_interests_heading = /** @type {(inputs: Onboarding_V1_Interests_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.username}，您想投資甚麼？`)
};

const ko_kr2_onboarding_v1_interests_heading = /** @type {(inputs: Onboarding_V1_Interests_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.username}님, 무엇에 투자하고 싶으신가요?`)
};

const ru_ru2_onboarding_v1_interests_heading = /** @type {(inputs: Onboarding_V1_Interests_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Во что вы хотите инвестировать, ${i?.username}?`)
};

const es_419_onboarding_v1_interests_heading = /** @type {(inputs: Onboarding_V1_Interests_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿En qué quieres invertir, ${i?.username}?`)
};

/**
* | output |
* | --- |
* | "What do you want to invest in, {username}?" |
*
* @param {Onboarding_V1_Interests_HeadingInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_interests_heading = /** @type {((inputs: Onboarding_V1_Interests_HeadingInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Interests_HeadingInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_interests_heading(inputs)
	if (locale === "de") return de_onboarding_v1_interests_heading(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_interests_heading(inputs)
	if (locale === "tr") return tr_onboarding_v1_interests_heading(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_interests_heading(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_interests_heading(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_interests_heading(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_interests_heading(inputs)
	return es_419_onboarding_v1_interests_heading(inputs)
});